export const AUTH_EXEMPT_VIEWS = [
    'SignUp',
    'SignIn',
    'SignOut',
    'ForgotPassword',
    'ResetPassword',
    'Activate',
]



// WEBPACK FOOTER //
// ./app/constants/authExempt.js